import { Controller } from "@hotwired/stimulus";

/**
 * NOTE:
 * This is the logic that would be loaded from the Sprintful script (https://app.sprintful.com/widget/v1.js), but slightly adjusted.
 * 1. It loads the Sprintful script asynchronously, because the synchronous load is blocking our own JS from running.
 * 2. It handles multiple widgets on the page.
 */
export default class extends Controller {
  static targets = ["widget", "paperworkContinueButton"];

  connect() {
    this.initIframes();

    if (this.hasPaperworkContinueButtonTarget) {
      this.paperworkContinueButtonTarget.disabled = true;
      this.listenForIframeConfirmation();
    }
  }

  initIframes() {
    if (this.hasWidgetTarget) {
      this.widgetTargets.forEach((widget) => {
        this.createIframe(widget);
      });
    }
  }

  createIframe(widget) {
    const widgetUrl = widget.dataset.url;
    if (!widgetUrl) return;

    const mark = widgetUrl.indexOf("?") > -1 ? "&" : "?";
    let fullUrl = widgetUrl + mark + "embeded=inline";

    if (widget.dataset.copyParentsQuery === "true") {
      const params = window.location.search.slice(1);
      if (params) {
        fullUrl += "&" + params;
      }
    }

    const iframe = document.createElement("iframe");
    iframe.src = fullUrl;
    iframe.width = "100%";
    iframe.height = "100%";
    iframe.frameBorder = "0";

    widget.appendChild(iframe);
  }

  listenForIframeConfirmation() {
    window.addEventListener("message", (e) => {
      if (
        e.data.event &&
        e.data.event.indexOf("sprintful-view-changed") > -1 &&
        e.data.payload.view === "confirmation"
      ) {
        this.paperworkContinueButtonTarget.disabled = false;
      }
    });
  }
}
